/* Simple singleton that holds the current PWA install state so any component
 * (e.g. the hamburger drawer) can read it and trigger install on demand. */

export type InstallState =
  | { status: 'idle' }
  | { status: 'available'; promptNow: () => Promise<void> }
  | { status: 'ios' }
  | { status: 'installed' };

type Listener = (s: InstallState) => void;

let state: InstallState = { status: 'idle' };
const listeners = new Set<Listener>();

export const installBus = {
  get: () => state,
  set(next: InstallState) {
    state = next;
    listeners.forEach((l) => l(next));
  },
  on(l: Listener) {
    listeners.add(l);
    l(state);
    return () => { listeners.delete(l); };
  },
};
